<script>
import useTools from "@/use/Tools";
import {onMounted, ref} from "vue";
import useSharedMethod from "@/use/SharedMethod";
import axios from "axios";

export default {
    name: "BlankPaySlipPreview",
    setup() {
        const {$route} = useTools();
        const {getBack} = useSharedMethod();

        const loading = ref(false);
        const dialog = ref(true);
        const blankPayslip = ref({details: []});
        const difference = ref({details: []});

        function preview() {
            loading.value = true;
            axios.get(`/payments/blankPaySlip/${$route.params.id}`).then((response) => {
                blankPayslip.value = response.data.blankPaySlip;
                difference.value = response.data.difference;
            }).finally(() => {
                loading.value = false;
            });
        }

        onMounted(() => preview());

        return {
            loading,
            dialog,
            blankPayslip,
            difference,
            preview,
            getBack
        }
    },
}
</script>

<template>
    <v-dialog
        v-model="dialog"
        persistent
        max-width="900"
    >
        <v-card>
            <w-toolbar color="teal" :title="`${blankPayslip.workerLastName} ${blankPayslip.workerFirstName}`"/>
            <v-card-text>
                <v-tabs centered>
                    <v-tab>
                        <v-icon left>mdi-checkbox-blank-outline</v-icon>
                        {{ $t('module.blank_pay_slips') }}
                    </v-tab>
                    <v-tab>
                        <v-icon left>mdi-vector-difference</v-icon>
                        {{ $t('pay_slip.difference') }}
                    </v-tab>

                    <v-tab-item>
                        <v-container fluid>
                            <v-skeleton-loader
                                v-show="loading"
                                ref="skeleton"
                                :type="'table'"
                                class="mx-auto"
                            />
                            <pay-slip-component
                                v-show="!loading"
                                :pay_slip="blankPayslip"
                            />
                        </v-container>
                    </v-tab-item>
                    <v-tab-item>
                        <v-container fluid>
                            <pay-slip-component
                                v-show="!loading"
                                :pay_slip="difference"
                            />
                        </v-container>
                    </v-tab-item>
                </v-tabs>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <w-btn-close @press="getBack"/>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>